import { useQuery } from "@tanstack/react-query";
import { McpUsageSummaryView } from "components/McpUsage";
import { Loader } from "components/Loader";
import { getMcpUsageSummary } from "../McpUsage.requests";

const McpUsageSummary = ({ companyId }: { companyId: number }) => {
  const summary = useQuery({
    queryKey: ["companyMcpUsageSummary", companyId],
    queryFn: () => getMcpUsageSummary(companyId),
  });

  if (summary.isLoading || !summary.data) return <Loader />;

  return <McpUsageSummaryView {...summary.data} />;
};

export { McpUsageSummary };
